export default [
  {
    position: "absolute",
    top: 3,
    left: 12,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "teamMembersP3.ttTextOne",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_TeamMember_Navigation_Home",
    index: 0,
  },
  {
    position: "absolute",
    top: 3,
    left: 33.9,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "teamMembersP3.ttTextThree",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_TeamMember_Navigation_Dashboards",
    index: 1,
  },
  {
    position: "absolute",
    top: 3,
    left: 38.9,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "teamMembersP3.ttTextTwo",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_TeamMember_Navigation_Reports",
    index: 2,
  },
  {
    position: "absolute",
    top: 13,
    left: 17,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "teamMembersP3.mTitleOne",
    mBody: "teamMembersP3.mBodyOne",
    id: "HR_TeamMember_Info_EmployeeDetails",
    infoIcon: true,
    isAction: false,
    index: 3,
  },
  {
    position: "absolute",
    top: 54.5,
    left: 12.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 2,
    tooltipText: "teamMembersP3.ttTextFour",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_TeamMember_Navigation_AdamGibson",
    index: 4,
  },
];
